import React from 'react';

import { Box } from '@mui/material';
import { snapshotPanesStyles } from 'app/shared/modules/EntityAuditHistory/EntityAuditHistory.styles';
import PropTypes from 'prop-types';

import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';
import RawTemplateJsonPane from '../RawTemplateJsonPane';

const RawTemplateJsonTab = ({ auditId, sides }) => (
  <Box data-testid={FormChangeHistoryTestIds.RAW_JSON} sx={snapshotPanesStyles}>
    {sides.map(side => (
      <RawTemplateJsonPane auditId={auditId} key={side} side={side} />
    ))}
  </Box>
);

RawTemplateJsonTab.propTypes = {
  auditId: PropTypes.string.isRequired,
  sides: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default RawTemplateJsonTab;
